<template>
  <v-content>
    <v-container style="max-width: 1000px; background-color: white">
      <v-layout column>
        <v-layout align-center class="mb-4">
          <v-spacer />

          <v-flex>
            <v-layout column align-center>
              <v-layout
                v-if="firm && firm.medium_url"
                align-center
                justify-center
                class="px-3 pt-4 logo-container"
              >
                <img :src="firm.medium_url" class="logo" />
              </v-layout>
              <div
                v-if="firm && !firm.preferences.hide_name_from_email"
                :class="firm.thumb_url ? 'title' : 'headline'"
                class="primary--text font-weight-bold mb-2"
              >
                {{ firm.name }}
              </div>
              <v-flex
                v-if="questionnaireTemplate"
                class="text-xs-left display-1 primary--text font-weight-bold mb-1"
                :class="$vuetify.breakpoint.smAndUp ? 'display-1' : 'title'"
              >
                {{ questionnaireTemplate.name }}
              </v-flex>
            </v-layout>
            <div
              v-if="
                questionnaireTemplate &&
                  questionnaireTemplate.preferences &&
                  questionnaireTemplate.preferences.introduction
              "
              class="text-xs-center mb-4 font-weight-bold font-italic body-2"
            >
              {{ questionnaireTemplate.preferences.introduction }}
            </div>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout column justify-center align-center>
          <v-flex xs12 sm8 class="form-container">
            <v-flex
              v-if="
                questionnaireTemplate &&
                  questionnaireTemplate.preferences &&
                  questionnaireTemplate.preferences.footnote
              "
            >
              <div
                class="text-xs-left subheading grey--text text--darken-4 mb-4"
                v-html="questionnaireTemplate.preferences.footnote"
              />
            </v-flex>
            <v-alert
              :value="true"
              outline
              block
              :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
              color="primary"
              class="text-xs-left mb-4"
            >
              Before you start, please fill out the following information so we
              can save your progress.
            </v-alert>

            <v-form
              ref="form1"
              v-model="userValid"
              class="mt-2"
              @submit="submit"
            >
              <div v-if="message">
                <v-layout class="mb-2">
                  <p style="font-size: 17px">{{ message }}</p>
                </v-layout>

                <v-layout>
                  <v-btn
                    class="primary text-none"
                    style="border-radius: 2px"
                    block
                    large
                    type="button"
                    @click.prevent="message = null"
                  >
                    Back
                  </v-btn>
                </v-layout>
              </div>

              <div v-else>
                <v-layout>
                  <v-flex xs12 class="pr-2">
                    <div
                      v-if="signInWithPhoneNumberEnabled"
                      class="text-xs-left pb-2"
                    >
                      Email or phone number
                      <span class="error--text">*</span>
                    </div>
                    <div v-else class="text-xs-left pb-2">
                      Email
                      <span class="error--text">*</span>
                    </div>
                    <v-text-field
                      class="default-input"
                      solo
                      name="username"
                      :placeholder="
                        signInWithPhoneNumberEnabled
                          ? 'Enter your email or phone number'
                          : 'Enter your email'
                      "
                      type="text"
                      v-model="username"
                      :rules="usernameRules"
                      :disabled="newUserForm || showPasswordInput"
                      required
                    />
                  </v-flex>
                </v-layout>

                <div v-if="showPasswordInput">
                  <div class="text-xs-left">
                    Password
                    <span class="error--text">*</span>
                  </div>
                  <v-text-field
                    name="password"
                    :label="
                      showPasswordInput
                        ? 'Enter password here.'
                        : 'Create a new password'
                    "
                    id="password"
                    type="password"
                    required
                    :rules="passwordRules"
                    v-model="password"
                    class="default-input"
                    solo
                  />
                </div>

                <template v-if="newUserForm">
                  <v-layout wrap>
                    <v-flex xs12 class="pr-2">
                      <div class="text-xs-left pb-2">
                        First name
                        <span class="error--text">*</span>
                      </div>
                      <v-text-field
                        class="default-input"
                        solo
                        label="First name"
                        type="text"
                        v-model="firstName"
                        :rules="fieldRules"
                        required
                      />
                    </v-flex>

                    <v-flex xs12 class="pr-2">
                      <div class="text-xs-left pb-2">
                        Last name
                        <span class="error--text">*</span>
                      </div>
                      <v-text-field
                        class="default-input"
                        solo
                        label="Last name"
                        type="text"
                        v-model="lastName"
                        :rules="fieldRules"
                        required
                      />
                    </v-flex>
                  </v-layout>
                </template>

                <v-layout
                  v-if="showVerificationCodeForm"
                  class="content-container"
                >
                  <v-form @submit="submitVerificationCode" class="pa-2">
                    <v-card-text>
                      <div class="text-xs-left">
                        A verification code has been sent to your
                        {{
                          showVerificationCodeForm === 'sms'
                            ? 'phone'
                            : 'email'
                        }}: <b>{{ verificationInfo }}</b> (masked for security)
                        <br />
                        Please enter it below to log in.
                      </div>
                      <v-text-field
                        name="verificationCode"
                        label="Enter verification code"
                        type="text"
                        v-model="verificationCode"
                        required
                        class="default-input mt-3"
                        solo
                      >
                      </v-text-field>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn
                        flat
                        outline
                        @click="showVerificationCodeForm = false"
                        class="text-capitalize"
                        >Back</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        type="submit"
                        class="text-capitalize"
                        :loading="loginLoading"
                      >
                        Login
                      </v-btn>
                    </v-card-actions>
                    <v-card-actions>
                      <v-btn
                        @click="resetSignInMethod()"
                        class="mt-2 text-capitalize"
                        flat
                        block
                      >
                        {{ $t('signin.signInUsingADifferentWay') }}
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-layout>

                <v-layout column v-else-if="showPasswordInput">
                  <v-layout>
                    <v-btn
                      class="text-none"
                      style="border-radius: 2px"
                      block
                      large
                      outline
                      type="button"
                      @click.prevent="showPasswordInput = false"
                    >
                      Back
                    </v-btn>

                    <v-spacer />

                    <v-btn
                      class="primary text-none"
                      style="border-radius: 2px"
                      block
                      large
                      type="submit"
                      :loading="loading"
                      :disabled="!userValid"
                    >
                      Sign In
                    </v-btn>
                  </v-layout>

                  <v-layout column>
                    <v-btn
                      @click="
                        $router.push(
                          `/reset-password?email=${encodeURIComponent(
                            email || '',
                          )}`,
                        )
                      "
                      class="mt-4 py-2 text-capitalize"
                      flat
                      block
                    >
                      {{ $t('signin.forgotPassword') }}
                    </v-btn>

                    <v-btn
                      @click="resetSignInMethod()"
                      class="mt-1 py-2 text-capitalize"
                      flat
                      block
                    >
                      {{ $t('signin.signInUsingADifferentWay') }}
                    </v-btn>
                  </v-layout>
                </v-layout>

                <v-layout v-else-if="newUserForm">
                  <v-btn
                    class="text-none"
                    style="border-radius: 2px"
                    block
                    large
                    outline
                    type="button"
                    @click.prevent="newUserForm = false"
                  >
                    Back
                  </v-btn>

                  <v-spacer />

                  <v-btn
                    class="primary text-none"
                    style="border-radius: 2px"
                    block
                    large
                    type="submit"
                    :loading="loading"
                    :disabled="!userValid"
                  >
                    Sign up
                  </v-btn>
                </v-layout>

                <v-layout v-else>
                  <v-btn
                    class="primary text-none"
                    style="border-radius: 2px"
                    block
                    large
                    type="submit"
                    :loading="loading"
                    :disabled="!userValid"
                  >
                    Continue
                  </v-btn>
                </v-layout>
              </div>

              <v-layout class="mt-5 mb-5">
                <v-divider />
              </v-layout>

              <v-layout
                column
                v-if="
                  firm &&
                    (!isEmpty(firm.preferences.support_email) ||
                      !isEmpty(firm.preferences.phone_number))
                "
              >
                <h2><p class="text-xs-center">Contact Us</p></h2>
              </v-layout>

              <v-layout>
                <v-btn
                  v-if="firm && !isEmpty(firm.preferences.support_email)"
                  class="text-none"
                  style="border-radius: 2px"
                  outline
                  block
                  large
                  :href="'mailto:' + firm.preferences.support_email"
                >
                  Email us at {{ firm.preferences.support_email }}
                </v-btn>
              </v-layout>

              <v-layout>
                <v-btn
                  v-if="
                    firm &&
                      firm.preferences &&
                      firm.preferences.show_phone_number &&
                      !isEmpty(firm.preferences.phone_number)
                  "
                  class="text-none"
                  style="border-radius: 2px"
                  outline
                  block
                  large
                  :href="'tel:' + firm.preferences.phone_number"
                >
                  Call us at {{ firm.preferences.phone_number }}
                </v-btn>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </v-content>
</template>
<script>
import API from '@/api';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { mapGetters } from 'vuex';
import UtilsMixins from '../../mixins/UtilsMixins';
import queryString from 'query-string';
import firebase from '@/firebase';

export default {
  name: 'TheTemplate',
  data() {
    return {
      userValid: false,
      newUserForm: false,
      showPasswordInput: false,
      showVerificationCodeForm: false,
      verificationInfo: null,
      verificationCode: null,
      username: '',
      password: '',
      firm: null,
      firstName: '',
      lastName: '',
      fieldRules: [v => !!v || 'This field is required'],
      usernameRules: [
        v => !!v || 'Username is required',
        v =>
          this.signInWithPhoneNumberEnabled
            ? this.isEmail(v) ||
              this.isPhoneNumber(v) ||
              'Please enter an email or phone number. If a phone number, enter numbers only.'
            : this.isEmail(v) || 'Please enter a valid email.',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => v.length >= 6 || 'Password must have at least 6 characters.',
      ],
      signedUp: false,
      loading: false,
      questionnaireTemplate: null,
      message: null,
    };
  },
  computed: {
    ...mapGetters({
      loginLoading: 'loginLoading',
      signedInUser: 'user',
      currentUser: 'user',
    }),

    signInWithPhoneNumberEnabled() {
      return (
        this.firm &&
        this.firm.preferences &&
        this.firm.preferences.sign_in_with_phone_number_enabled
      );
    },

    hashId() {
      return this.$route.params.id;
    },

    taxYear() {
      return this.$route.query.taxYear;
    },

    firmGroupId() {
      return this.$route.query.firmGroupId;
    },

    createQuestionnaireUrl() {
      return (
        '/create-questionnaire-from-template?' +
        queryString.stringify({
          hashId: this.hashId,
          taxYear: this.taxYear,
        })
      );
    },
  },
  mixins: [UtilsMixins],
  methods: {
    isEmpty,
    moment,
    isEmail(value) {
      return /.+@.+/.test(value);
    },
    isPhoneNumber(value) {
      return /^\d*$/.test(value);
    },
    async submit(e) {
      e.preventDefault();

      try {
        this.loading = true;

        if (this.newUserForm === true) {
          await this.signUp();
        } else if (this.showPasswordInput === true) {
          await this.signIn();
        } else {
          await this.checkAccountExists();
        }
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message: e.message,
        });

        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    async submitVerificationCode(e) {
      try {
        e.preventDefault();

        this.$store.dispatch('setLoginLoading', true);

        const response = await API.auth.verifyVerificationCode({
          uid: this.uid,
          verificationCode: this.verificationCode,
        });

        const firebaseToken = await this.exchangeForFirebaseToken(
          response.data.auth_token,
        );

        const questionnaireUrl = await this.getQuestionnaireUrl();

        await this.$store.dispatch('userLogin', {
          authToken: firebaseToken,
          redirectPath: questionnaireUrl,
        });

        this.$store.dispatch('setLoginLoading', false);
      } catch (error) {
        this.$store.dispatch('application/setErrorNotification', {
          message: error.message
            ? error.message
            : 'Something went wrong. Please try again later.',
        });

        this.$store.dispatch('setLoginLoading', false);
      }
    },

    async resetSignInMethod() {
      try {
        const questionnaireUrl = await this.getQuestionnaireUrl();

        const response = await API.user.changeLoginMethod({
          uid: this.uid,
          redirect: questionnaireUrl,
        });

        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
            errorToSend: response.data.error,
            userEmail: this.currentUser.email,
          });
        } else {
          this.message = `Sent an email to ${this.email} with a link to reset your sign-in method.`;
          this.showVerificationCodeForm = false;
          this.showPasswordInput = false;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async exchangeForFirebaseToken(token) {
      this.$store.dispatch('setLoginLoading', true);

      const response = await API.auth.exchangeForFirebaseToken({
        soraban_token: token,
      });

      return response.data.firebase_token;
    },

    async checkAccountExists() {
      try {
        const response = await API.auth.getPreferredSignInMethod({
          username: this.username,
          templateId: this.questionnaireTemplate.id,
        });

        if (response.data && response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          const account = response.data;

          if (account) {
            if (account.passwordless) {
              const questionnaireUrl = await this.getQuestionnaireUrl();

              const {
                data: { message },
              } = await API.auth.sendAuthLink({
                uid: account.uid,
                accountantId: account.accountant_id,
                redirect: questionnaireUrl,
              });

              this.message = message;
            } else {
              switch (account.preferred_sign_in_method) {
                case 'password':
                  this.showPasswordInput = true;
                  break;
                case 'sms':
                  this.loading = true;
                  this.uid = account.uid;

                  try {
                    const phoneVerificationCode = await API.auth.sendSMSVerificationCode(
                      {
                        uid: account.uid,
                      },
                    );

                    this.verificationInfo = `*** - *** - ${phoneVerificationCode.data.phone}`;
                    this.showVerificationCodeForm = 'sms';
                  } catch (error) {
                    const { message } =
                      error && error.response && error.response.data;
                    this.$store.dispatch('application/setErrorNotification', {
                      message:
                        message ||
                        'There was something wrong. Please refresh the page and try again.',
                    });
                  } finally {
                    this.loading = false;
                  }
                  break;
                case 'email':
                  this.loading = true;
                  this.uid = account.uid;

                  try {
                    const emailVerificationCode = await API.auth.sendEmailVerificationCode(
                      {
                        uid: account.uid,
                      },
                    );

                    this.verificationInfo = emailVerificationCode.data.email;
                    this.showVerificationCodeForm = 'email';
                  } catch (error) {
                    const { message } =
                      error && error.response && error.response.data;
                    this.$store.dispatch('application/setErrorNotification', {
                      message:
                        message ||
                        'There was something wrong. Please refresh the page and try again.',
                    });
                  } finally {
                    this.loading = false;
                  }
                  break;
              }
            }
          } else {
            this.newUserForm = true;
          }
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: e
            ? e.message
            : 'Something went wrong. Please try again later.',
        });
      }
    },

    async getQuestionnaireUrl() {
      if (this.questionnaireTemplate.is_annual) {
        const {
          data: { questionnaire_id },
        } = await API.resource.getQuestionnaireIdByTemplate({
          hashId: this.hashId,
          username: this.username,
          taxYear: this.taxYear,
        });

        if (questionnaire_id) {
          return '/questionnaire?questionnaireId=' + questionnaire_id;
        } else {
          return this.createQuestionnaireUrl;
        }
      } else {
        return this.createQuestionnaireUrl;
      }
    },

    async verifyPasswordForFirebaseToken() {
      const response = await API.auth.verifyPasswordForFirebaseToken({
        username: this.username,
        password: this.password,
      });

      return response.data.firebase_token;
    },

    async signIn() {
      const questionnaireUrl = await this.getQuestionnaireUrl();

      const firebaseToken = await this.verifyPasswordForFirebaseToken({
        username: this.username,
        password: this.password,
      });

      await this.$store.dispatch('userLogin', {
        authToken: firebaseToken,
        redirectPath: questionnaireUrl,
      });
    },

    async signUp() {
      try {
        const response = await API.auth.firmSelfSignUp({
          email: this.isEmail(this.username) ? this.username : null,
          phone_number: this.isPhoneNumber(this.username)
            ? this.username
            : null,
          fname: this.capitalizeWords(this.firstName),
          lname: this.capitalizeWords(this.lastName),
          templateHashId: this.hashId,
          year: this.taxYear,
          firm_group_id: this.firmGroupId,
        });

        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
          console.log(response.data.error);
        } else {
          const firebaseToken = await this.exchangeForFirebaseToken(
            response.data.auth_token,
          );

          await this.$store.dispatch('userLogin', {
            authToken: firebaseToken,
            redirectPath: this.createQuestionnaireUrl,
          });
        }
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message: e.message,
        });

        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    async getFirm() {
      try {
        const response = await API.resource.getFirm(this.hashId);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'Invalid Link',
          });
          this.$router.push('/signin');
        }
        this.firm = response.data;
      } catch (e) {
        console.log(e);
      }
    },

    async getTemplate() {
      try {
        const response = await API.resource.getTemplate(this.hashId);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'Invalid Link',
          });
          this.$router.push('/signin');
        }
        this.questionnaireTemplate = response.data;
      } catch (e) {
        console.log(e);
      }
    },

    async signOut() {
      this.$store.dispatch('setLoginLoading', true);
      await firebase.auth().signOut();
      await this.$store.dispatch('userSignOutSilently');
    },
  },

  async created() {
    if (!isEmpty(this.currentUser)) {
      await this.signOut();
    }

    await this.getFirm();
    await this.getTemplate();
  },
};
</script>

<style lang="postcss" scoped>
.form-container {
  width: 400px;
}
.have-an-account__question {
  color: #1d2b4c;
}
.message-title {
  line-height: 30px !important;
}
.logo-container {
  flex: 0;
}
.logo {
  height: 60px;
  width: auto;
}
</style>
